<script lang="ts">
    import type {
        SchedularVehicle,
        SchedularVehicles,
    } from "../types";
    import type {OverlappingJobs} from "../overlappingJobs.svelte";
    import {getOverlappingHeight} from "../lib";
    import Debug from "@/components/Debug.svelte";

    type Props = {
        vehicles: SchedularVehicles;
        rowStepPx: number;
        overlappingJobs: OverlappingJobs;
    };

    let {
        vehicles,
        rowStepPx,
        overlappingJobs
    }: Props = $props();

    const getRowHeight = (vehicle: SchedularVehicle) => {
        let overlappingHeight = getOverlappingHeight(
            vehicle,
            overlappingJobs,
        );
        return rowStepPx * overlappingHeight;
    };

    const getUsers = (
        vehicles: SchedularVehicles,
    ) => vehicles;
</script>

{#each getUsers(vehicles) as vehicle (vehicle.id)}
    <div
        class="user"
        class:unassigned={vehicle.id === 'unassigned'}
        class:site-visits={vehicle.id === 'site-visits'}
        style={`height: ${getRowHeight(vehicle)}px`}
    >
        <h4>
            <b>{vehicle.make} - {vehicle.registration}</b>
        </h4>
    </div>
{/each}

<style lang="scss">
    .user {
        display: flex;
        flex-direction: column;
        border: solid 1px #333;
        transition: height 200ms;
        background: var(--clr-surface-0);
        color: var(--clr-on-surface-1);

        &:nth-child(odd),
        &:nth-child(odd) h4 {
            background: var(--clr-surface-1);
        }

        overflow: auto;
        padding: 0.25rem;
    }

    h4 {
        position: sticky;
        top: 0;
        background: var(--clr-surface-0);
    }

    .user.unassigned {
        background: hsl(45deg 100% 95% / 0.15);
        border: 2px solid hsl(45deg 100% 50%);

        h4 {
            background: hsl(45deg 100% 90% / 0.2);
            color: hsl(45deg 100% 70%);
        }
    }

    :global(.dark) .user.unassigned {
        background: hsl(45deg 80% 30% / 0.3);

        h4 {
            background: hsl(45deg 80% 25% / 0.4);
            color: hsl(45deg 100% 70%);
        }
    }

    .user.unassigned:nth-child(odd),
    .user.unassigned:nth-child(odd) h4 {
        background: hsl(45deg 100% 92% / 0.15);
    }

    :global(.dark) .user.unassigned:nth-child(odd),
    :global(.dark) .user.unassigned:nth-child(odd) h4 {
        background: hsl(45deg 80% 28% / 0.3);
    }

    .user.site-visits {
        background: hsl(210deg 100% 95% / 0.15);
        border: 2px solid hsl(210deg 100% 50%);

        h4 {
            background: hsl(210deg 100% 90% / 0.2);
            color: hsl(210deg 100% 70%);
        }
    }

    :global(.dark) .user.site-visits {
        background: hsl(210deg 80% 30% / 0.3);

        h4 {
            background: hsl(210deg 80% 25% / 0.4);
            color: hsl(210deg 100% 70%);
        }
    }

    .user.site-visits:nth-child(odd),
    .user.site-visits:nth-child(odd) h4 {
        background: hsl(210deg 100% 92% / 0.15);
    }

    :global(.dark) .user.site-visits:nth-child(odd),
    :global(.dark) .user.site-visits:nth-child(odd) h4 {
        background: hsl(210deg 80% 28% / 0.3);
    }
</style>
